import React, { Component } from 'react';

import { BrowserRouter as Router , Route} from 'react-router-dom'
import Media from 'react-media'

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {CCActions, updateLocale, Root,VerifyEmail, FirebaseUtils, LeagueRoute } from "./cc-imports";
import FBHome from "./screens/Home/FBHome";


class App extends Component {

    componentDidMount() {
        //this.props.actions.initializeFirebase(this.props.actions.getUserByEmail);
        updateLocale('en',()=>{
            //this.setState({initDone: true});
        });

    }

    componentWillMount(){
        FirebaseUtils.initializeFireBase(this.props.actions);

    }



    render() {
        return (
            <Router>
                <div>
                    <FBHome />
                    <Media query={"(min-device-width : 320px) and (max-device-width : 736px)"}>
                            <Route exact path="/match/:matchId/:leagueId?" component={LeagueRoute} />
                    </Media>
                    <Media query={"(min-device-width : 737px)"}>
                        <Route exact path="/match/:matchId/:leagueId?" component={Root} />
                    </Media>
                    <Route exact path="/" component={Root} />
                    <Route path="/verifyEmail" component={VerifyEmail} />
                </div>
            </Router>

        );
    }
}

export default connect(state=>({
    //user: state.user.user
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(App);


// WEBPACK FOOTER //
// ./src/app/App.js